import { GunslingerJobStatus } from '@/const/const.ts'
import useStore from '@/stores/useStore.js'
import { useMemo } from 'react'
import { useProvisionedVMsQuery } from './useProvisionedVMsQuery.ts'
import { isVMActive } from '@/lib/iteration-utils.ts'

type Project = {
  iterations?: {
    lastIteration?: {
      vmStatus?: GunslingerJobStatus
    }
  }
  createdBy: string
}

export const useVMsUsage = () => {
  const { projects, user } = useStore(state => ({
    projects: state.projects,
    user: state.user,
  }))

  const provisionedVMsQuery = useProvisionedVMsQuery()

  return useMemo(() => {
    const userProjectsWithActiveVMs = (projects ?? []).filter(
      (project: Project) =>
        project.createdBy === user.id && isVMActive(project.iterations?.lastIteration?.vmStatus)
    ) as Project[]

    if (!provisionedVMsQuery.isSuccess) {
      return {
        userProjectsWithActiveVMs,
        provisionedVMs: null,
        isLoading: true,
        reachedLimit: false,
      } as const
    }
    return {
      userProjectsWithActiveVMs,
      provisionedVMs: provisionedVMsQuery.data,
      isLoading: provisionedVMsQuery.isLoading,
      reachedLimit: !provisionedVMsQuery.isSuccess
        ? false
        : userProjectsWithActiveVMs.length >= provisionedVMsQuery.data,
    }
  }, [
    projects,
    user.id,
    provisionedVMsQuery.data,
    provisionedVMsQuery.isSuccess,
    provisionedVMsQuery.isLoading,
  ])
}
